import {
  UpdateField,
  FetchMobileTasksRequest,
  SetDefaultData,
  AutoAssignTasksRequest,
} from './mobile-tasks.actions'
import {
  getAutoAssignTasksState,
  getMobileTasksState,
} from './mobile-tasks.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import ListTrait from 'src/app/traits/list.trait'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'
import { filtersToDbQuery } from '@shared/shared.utils'
import { TableFilterType } from '@shared/shared.types'
import { getMobileTaskTypesState } from '@shared/shared.select'
import { FetchMobileTaskTypesRequest } from '@shared/shared.actions'
import Swal from 'sweetalert2'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-mobile-tasks',
  templateUrl: './mobile-tasks.component.html',
  styleUrls: ['./mobile-tasks.component.css'],
})
export class MobileTasksComponent
  extends ListTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private autoAssignState$: Subscription
  private route$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public pagination: any = {}
  public columns: object[] = [
    {
      prop: 'objectLabelId',
      name: 'OBJECT_CODE',
      sortable: true,
      filterable: true,
      filterType: TableFilterType.String,
      filterKey: 'objectLabelId.label',
      sortProp: 'objectLabelId.label',
      template: 'code',
    },
    {
      prop: 'objectType',
      name: 'OBJECT_TYPE',
      sortable: true,
      template: 'objectType',
    },
    {
      prop: 'mobileUser',
      name: 'USER',
      sortable: true,
      render: (row: any) => row.get('displayName'),
    },
    {
      prop: 'type',
      name: 'TYPE',
      sortable: true,
      filterable: true,
      filterType: TableFilterType.String,
      template: 'type',
      select$: null, // Will be set in ngOnInit
    },
    // {
    //   prop: 'assessibility',
    //   name: 'ASSESSIBILITY',
    //   sortable: true,
    //   template: 'assessibility',
    // },
    // {
    //   prop: 'status',
    //   name: 'STATUS',
    //   sortable: true,
    //   template: 'status',
    // },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  public filters: any[]
  public autoAssignLoading = false

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
    public translateService: TranslateService,
  ) {
    super(router)
  }

  ngOnInit() {
    // Set the select$ property after store is initialized
    (this.columns[4] as any).select$ = this.store.pipe(select(getMobileTaskTypesState))
    
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.store.dispatch<any>(new SetDefaultData('autoAssignTasks'))

    this.autoAssignState$ = this.store
      .pipe(select(getAutoAssignTasksState))
      .subscribe((state) => {
        this.autoAssignLoading = state.get('isLoading')
        const assignedTaskCount = state.get('assignedTaskCount')

        if (!this.autoAssignLoading && assignedTaskCount !== null) {
          Swal.fire({
            text: `${assignedTaskCount} ${this.translateService.instant(
              assignedTaskCount == 1
                ? 'TASK_ASSIGNED_TO_USERS'
                : 'TASKS_ASSIGNED_TO_USERS',
            )}`,
            icon: 'info',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok',
            width: 300,
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
            }
          })
        }
      })

    this.state$ = this.store
      .pipe(select(getMobileTasksState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
        this.filters = state.get('filters').toJS()
        this.pagination = this.state.get('pagination').toJS()

        if (
          state.get('shouldReload') !== this.shouldReload &&
          state.get('shouldReload')
        ) {
          this.handleFilterChange()
        }
        this.shouldReload = state.get('shouldReload')
      })

    this.handleFilterChange()
    this.store.dispatch<any>(new FetchMobileTaskTypesRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.autoAssignState$.unsubscribe()
  }

  autoAssign() {
    this.store.dispatch<any>(new AutoAssignTasksRequest())
  }

  handleFilterChange(data?: any) {
    const filters = data?.filters ?? this.filters
    const pagination = data?.pagination ?? this.state.get('pagination').toJS()
    const { page, page_size, sort, order_by } = pagination

    this.store.dispatch(new UpdateField('filters', filters, 'list'))
    this.store.dispatch(new UpdateField('pagination', pagination, 'list'))

    this.store.dispatch<any>(
      new FetchMobileTasksRequest({
        filters: {
          ...filtersToDbQuery(filters),
        },
        pageSize: parseInt(page_size, 10),
        page: parseInt(page, 10) - 1,
        sort: {
          order: sort?.toUpperCase(),
          prop: order_by,
        },
      }),
    )
  }
}
